import React from "react";
import IconBase from "./IconBase";

const Pie = (props: any) => {
  return (
    <IconBase viewBox="0 0 32 32" {...props}>
      <path d="M14.438 2.5c-8 0.063-14.438 6.563-14.438 14.5 0 8.063 6.5 14.563 14.5 14.563 3.5 0 6.625-1.188 9.125-3.188l-9.188-10.813zM31.313 15.563c0-0.188 0-0.375 0-0.563 0-8.063-6.5-14.563-14.563-14.563 0 0-0.063 0-0.063 0v15.125zM32 17.75h-14.563l9.125 10.813c3.188-2.563 5.313-6.438 5.438-10.813z" />
    </IconBase>
  );
};

export default Pie;
